import TrackBadgeIcon from "../common/icons/badges/TrackBadgeIcon";
import ReflectionBadgeIcon from "../common/icons/badges/ReflectionBadgeIcon";
import GoalsBadgeIcon from "../common/icons/badges/GoalsBadgeIcon";
import NewElementIcon from "../common/ActionsMenuButton/icons/NewElementIcon";

import { openURL } from "../../../helpers/utils";
import AppMessages from "../../../config/AppMessages";

import moment from "moment";

const STORAGE_KEYS = {
  goals: "showGoalTutorials",
  track: "showTrackTutorials",
  reflection: "showReflectionTutorials",
};

const scheduleCall = {
  id: 100,
  name: "Schedule Guide Call",
  key: "has_scheduled_call",
  page: "rn:home_card",
  isComplete: true,
};

const tutorials = [
  /* {
    id: 101,
    name: "Reflect on Last Week",
    action: "tutorials",
    key: "reflection",
    storageKey: STORAGE_KEYS.reflection,
    page: "rn:home_card",
    isComplete: false,
    showForActiveUser: true,
    iconTag: NewElementIcon,
    badgeIcon: ReflectionBadgeIcon,
    badgeText: "Reflector LV 1",
  }, */
  {
    id: 102,
    name: "Set a Goal",
    action: "tutorials",
    key: "goals",
    storageKey: STORAGE_KEYS.goals,
    page: "rn:home_card",
    isComplete: false,
    showForActiveUser: true,
    iconTag: NewElementIcon,
    badgeIcon: GoalsBadgeIcon,
    badgeText: "Goalsetter LV 1",
  },
  {
    id: 103,
    name: "Track your time",
    action: "tutorials",
    key: "track",
    storageKey: STORAGE_KEYS.track,
    page: "rn:journal",
    isComplete: false,
    iconTag: NewElementIcon,
    badgeIcon: TrackBadgeIcon,
    badgeText: "Time Keeper LV 1",
  },
];

const knowledgeBase = {
  id: 104,
  name: "Check Out the Knowledge Base",
  page: "rn:knowledge_base",
  key: "knowledge_base",
  isComplete: false,
};

// ------------------------------------- METHODS -------------------------------------
const _initCompletedState = (items, tutorialsOptions = {}) => {
  return items.map((opt) => {
    return {
      ...opt,
      isComplete: tutorialsOptions[opt.key],
    };
  });
};

const getTutorialsList = (tutorialsOptions) => {
  return _initCompletedState(tutorials, tutorialsOptions);
};

const tutorialsCardOptions = (tutorialsOptions) => {
  return _initCompletedState([scheduleCall, ...tutorials], tutorialsOptions);
};

const getStartedPageOptions = (tutorialsOptions) => {
  return _initCompletedState(
    [scheduleCall, ...tutorials, knowledgeBase],
    tutorialsOptions,
  );
};

const getActiveUserOptions = (tutorialsOptions) => {
  const options = tutorials.filter((t) => t.showForActiveUser);
  return _initCompletedState(options, tutorialsOptions);
};

const onTutorialClicked = (controller, b, isFromCard = true) => {
  if (!b.page) return;

  if (b.key == "has_scheduled_call") {
    return openURL(AppMessages.GuidesEmail);
  }

  if (b.page != "rn:knowledge_base" && b.storageKey) {
    controller.toggleTutorialsMode({ [b.storageKey]: true });
  } else {
    saveTutorialStatus(controller, { knowledge_base: true });
  }

  if (b.key == "reflection") {
    startReflectionTutorial(controller, isFromCard);
  } else {
    controller.changePage(b.page, { args: {} });
  }
};

const getLastWeekDate = () => {
  return moment().startOf("isoWeek").add(-1, "week").format("YYYY-MM-DD");
};

const startReflectionTutorial = (controller, isFromCard) => {
  const { has_scheduled_call } = controller.state?.settings || {};
  let page =
    true || (has_scheduled_call && isFromCard) // 29.04: skip schedule call card
      ? "rn:onboarding_template"
      : "rn:home_card";

  controller.changePage(page, {
    args: {
      args: { tutorialDone: null },
      reflection: {
        edit_time_unit: "week",
        edit_object: "time",
        edit_day: getLastWeekDate(),
      },
      fetchFromApi: true,
    },
  });
};

const isTutorialMode = (settings = {}) => {
  if (!settings) return false;

  let isTutorial = false;
  Object.values(STORAGE_KEYS).forEach((value) => {
    if (settings[value]) {
      isTutorial = true;
    }
  });

  return isTutorial;
};

const saveTutorialStatus = (controller, data = {}, callback = () => {}) => {
  const userSettings = controller.state.settings || {};
  const tutorialSettings = userSettings.tutorials || {};
  const newSettings = { ...tutorialSettings, ...data };

  const action = {
    action: "save",
    target: "tutorials",
    ...newSettings,
  };

  controller.cardActionWithCallback(action, callback);
};

const TutorialsHelper = {
  STORAGE_KEYS,
  tutorials,
  getTutorialsList,
  tutorialsCardOptions,
  getStartedPageOptions,
  onTutorialClicked,
  saveTutorialStatus,
  isTutorialMode,
  getLastWeekDate,
  getActiveUserOptions,
};

export default TutorialsHelper;
